module.exports = __webpack_public_path__ + "img/google-ads.392b4d20.svg";